$mol_view_tree2_to_js_test_ex_simple_empty_class_foo $mol_object
